import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Operations } from '../../_models/general.model';
const getThemes = createFeatureSelector<any>('themes');

export const getAllThemesLoading = createSelector(
  getThemes,
  (state: any) => state.themesLoading
);

/**
 * Get all themes
 */

export const getAllThemes = createSelector(
  getThemes,
  (state: any) => state.themes
);

/**
 * Get Theme Detals
 */
export const getThemeDetail = createSelector(
  getThemes,
  (state: any) => state.themeDetails
);

/**
 * Select operations
 */
export const getThemesOperations = createSelector(
  getThemes,
  (state: Operations) => state.operations
);

/**
 * Get Default theme for table
 */
export const getDefaultThemeForTable = createSelector(
  getThemes,
  (state: any) => state.defaultTheme
);
